// @flow

import { Component } from '../../jsti/core';
import Notifications from '../../constants/Notifications';
import type { Filter } from '../../classes/Url/Url';

export default class FilterComponent extends Component {
  name: string;
  id: string;
  group: string;

  /**
   * Initialize a new filter component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.name = pEl.dataset.name;
    this.id = pEl.dataset.id;
    this.group = pEl.dataset.group;

    if (!this.name || !this.id || !this.group) {
      throw new Error('All data attributes are required!');
    }
  }

  /**
   * Send a filter notification
   */
  sendFilterNotification(): void {
    this.notify(Notifications.FILTER, { group: this.group });
  }

  /**
   * Helper function to convert the properties of the component to a filter type
   */
  properties(): Filter {
    return {
      id: this.id,
      name: this.name,
      group: this.group
    };
  }
}
